import { Card } from '@themesberg/react-bootstrap'
import React from 'react'
import Header from '../Header'
import RouteWithSidebar from '../RouteWithSidebar'
import usePrivateRoute from './usePrivateRoute'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { CommonRoutes } from '../../routes'
import {ROLE_ENUMS} from "../../pages/Super-Admin/Staff/components/constant"

const PrivateRoute = ({ isWithoutCard = false, children, isWithoutHeader = false, module, isHideMargin=false  , isOnlySuperAdmin=false}) => {
  const { accessToken, loading } = usePrivateRoute()
  const { adminPermissions , adminDetails} = useSelector(state => state.admins)

  return (
    accessToken &&
    !loading
    && (
      adminPermissions &&
      ((!module || adminPermissions[Object.keys(module)?.[0]]?.includes(module[Object.keys(module)?.[0]])|| isOnlySuperAdmin  || adminDetails?.adminRoleId === ROLE_ENUMS?.SUPERADMIN)
        ? (
          <RouteWithSidebar key={children} isWithoutCard={isWithoutCard} isHideMargin={isHideMargin}>
            {/* {isTenantRoute && !isWithoutHeader && <Header />} */}
            {isWithoutCard
              ? children
              : <Card className=''>{children}</Card>}
          </RouteWithSidebar>)
        : <Navigate replace to={CommonRoutes.NotFound} />)
    )
  )

  // return (
  //   accessToken ? (
  //   <RouteWithSidebar key={children}>
  //     {isTenantRoute && !isWithoutHeader && <Header />}
  //     {isWithoutCard
  //       ? children
  //       : <Card className='p-2'>{children}</Card>}
  //   </RouteWithSidebar>)
  // : <Navigate replace to={CommonRoutes.NotFound} />)
}

export default PrivateRoute
